import * as React from 'react';

import { Box, BoxProps } from '_lib/components/Box/Box';
import { Card } from '_lib/components/Card/Card';

export type CardBoxProps = BoxProps;

export const CardBox = (props: CardBoxProps): React.ReactElement => {
  const { children, ...boxProps } = props;
  return (
    <Box {...boxProps}>
      <Card variant='outlined'>
        <Box sx={{ margin: 0.75 }}>{children}</Box>
      </Card>
    </Box>
  );
};
